export default "__VITE_ASSET__BqMb4caF__"